export const ESC_KEY = 'Escape';